import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import TrackingInit from "./components/TrackingInit";
import ScrollToTop from "./components/ScrollToTop";

const BookCall = lazy(() => import("./pages/BookCall"));
const CaseStudyIndex = lazy(() => import("./pages/CaseStudyIndex"));
const CaseStudyDetail = lazy(() => import("./pages/CaseStudyDetail"));
const GetStarted = lazy(() => import("./pages/GetStarted"));
const ApplyThankYou = lazy(() => import("./pages/ApplyThankYou"));
const NotAFit = lazy(() => import("./pages/NotAFit"));
const About = lazy(() => import("./pages/About"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <TrackingInit />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/book" element={<BookCall />} />
              <Route path="/case-study" element={<CaseStudyIndex />} />
              <Route
                path="/case-study/:slug"
                element={<CaseStudyDetail />}
              />
              <Route path="/get-started" element={<GetStarted />} />
              <Route
                path="/get-started/thank-you"
                element={<ApplyThankYou />}
              />
              <Route path="/get-started/not-a-fit" element={<NotAFit />} />
              <Route path="/about" element={<About />} />

              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
